import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, string } from 'prop-types'

function Chip({ label, count = 0, isActive = false, onClick: handleClick }) {
  return (
    <button
      type="button"
      aria-pressed={isActive}
      disabled={count === 0}
      className={classnames(
        'variations-tab__chip',
        'cgt-body-base-semibold',
        isActive && 'variations-tab__chip--active',
      )}
      onClick={handleClick}
    >
      {label}
      {count > 0 && <span className="variations-tab__chip-count">{count}</span>}
    </button>
  )
}

Chip.propTypes = {
  label: string.isRequired,
  count: number,
  isActive: bool,
  onClick: func.isRequired,
}

export default memo(Chip)
